import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import vendorDetailsReducer from "../Reducers/Default";
import profileReducer from "../Reducers/Profile";
import productDetailSingleReducer from '../Reducers/ProductDetail/Single';
import ActionsReducers from "../Reducers/ActionReduer";
import packageReducer from "../Reducers/PackageWeight";
const rootReducer = combineReducers({
    "profileReducer": profileReducer,
    "vendorDetailsReducer":vendorDetailsReducer,
    "productDetailSingleReducer":productDetailSingleReducer,
    "ActionReducer":ActionsReducers,
    "packageReducer":packageReducer
})

const store = createStore(rootReducer,
    applyMiddleware(thunk)
)

export default store